import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { PopinAuthShowed } from '@app/core/user/store/actions';

@Component({
  selector: 'vc-login-register-screen',
  templateUrl: './login-register-screen.component.html',
  styleUrls: ['./login-register-screen.component.scss']
})
export class LoginRegisterScreenComponent implements OnInit {
  @Output()
  switchModal: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  popinForced: boolean;

  isMobile = false;

  constructor(private store: Store<IAppState>) {}

  ngOnInit() {
    this.store.select('device').subscribe(
      res => {
        if (res) {
          this.isMobile = !res.isMdUp;
        }
      },
      err => {}
    );

    this.store.dispatch(
      new PopinAuthShowed({
        type: 'welcome',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  switchTo(type: 'login' | 'register') {
    this.switchModal.emit(type);
  }
}
